import React, { PropTypes } from 'react';
import Modal from 'components/Modal';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import features from 'lib/common/features';

const AdaAttestation = React.createClass({
    propTypes: {
        handleSelection: PropTypes.func.isRequired,
        handleDeselection: PropTypes.func.isRequired,
        specialRequestOptions: PropTypes.array.isRequired
    },
    getInitialState: function() {
        return {
            validationError: false
        }
    },
    handleClose: function() {
        this.props.handleDeselection();
    },
    getAdaChoices: function(adaOptionEls) {
        let inputType = features.getOption('adaAttestation', 'inputType') ? features.getOption('adaAttestation', 'inputType') : 'radio';
        var adaChoices = reduce(adaOptionEls, (acc, item) => {
            if (item.type === inputType && item.checked) {
                acc[item.value] = true;
            }
            return acc;
        }, {});

        return isEmpty(adaChoices) ? null : adaChoices;
    },
    handleSubmit: function(e) {
        e.preventDefault();

        var adaChoices = this.getAdaChoices(e.target.elements);
        if (adaChoices) {
            this.props.handleSelection(
                adaChoices,
                this._specialRequestsEl.value
            );
        } else {
            this.setState({
                validationError: 'You must select at least one option'
            });
        }
    },
    render: function() {
        return (
            <Modal title="ADA Seating" onClose={this.handleClose}>
                <form className="ada-form" action=""
                    onSubmit={this.handleSubmit}>
                    <div className="ada-form__details">
                        <h3 className="ada-form__title">
                            You have selected accessible seating areas that
                            are solely for individuals who require the features
                            of these seats and their companions.
                        </h3>

                        <div className="ada-form__smallprint" dangerouslySetInnerHTML={{__html:features.getOption('adaAttestation', 'attestationSmallPrint')}}></div>
                    </div>

                    <div className="ada-form__fields">
                        <fieldset className="form-fieldset">
                            <legend className="form-fieldset__legend">
                                Member(s) of your party have requested ADA Seating,
                                If you need any special services or have any other
                                requirements please add them here:
                            </legend>

                            {this.state.validationError && (
                                <p className="field-error">{this.state.validationError}</p>
                            )}

                            <div className="field-group">
                                <ol className="field-optionlist field-optionlist--columns">
                                    {this.props.specialRequestOptions.map(option => (
                                        <li className="field-optionlist__item" key={option.option}>
                                            <label className="field-option">
                                                <input className="field-option__input"
                                                    name="ada-attestation[]" type={features.getOption('adaAttestation', 'inputType') ? features.getOption('adaAttestation', 'inputType') : 'radio'} value={option.option} />
                                                <span className="field-option__label">{option.option}</span>
                                            </label>
                                        </li>
                                    ))}
                                </ol>
                            </div>

                            <div className="field-group">
                                <label className="field-textarea">
                                    <span className="field-label field-textarea__label">
                                        Special requests
                                    </span>
                                    <textarea className="field-textare__input"
                                        id="specialRequests" name="specialRequests" rows={3}
                                        ref={el => this._specialRequestsEl = el} />
                                </label>
                            </div>

                            <div className="form-actions">
                                <input type="reset" className="syos-button syos-button--secondary"
                                    onClick={this.handleClose} value="Close" />
                                <input type="submit" className="syos-button" value="Continue" />
                            </div>
                        </fieldset>
                    </div>
                </form>
            </Modal>
        );
    }
});

export default AdaAttestation



// WEBPACK FOOTER //
// ./src/javascripts/app/components/AdaAttestation.js